(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rendi-contact"]) return;
  try {
    
  // Opens the Live chat. Tidio's stub queues open() until it's ready, so an early
  // click still opens it; before the stub exists, wait for tidioChat-ready. Tidio
  // comes from an async script, which `load` waits for: no stub at `load` means
  // it was blocked, and the button is disabled rather than doing nothing.
  if (!customElements.get('rendi-contact-chat')) {
    customElements.define('rendi-contact-chat', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button');
        if (!button) return;
        let waiting = false;
        button.addEventListener('click', () => {
          if (waiting) return;
          if (window.tidioChatApi) {
            window.tidioChatApi.open();
            return;
          }
          waiting = true;
          document.addEventListener('tidioChat-ready', () => {
            waiting = false;
            window.tidioChatApi.open();
          }, { once: true });
        });
        const disableIfBlocked = () => {
          if (!window.tidioChatApi) button.disabled = true;
        };
        if (document.readyState === 'complete') disableIfBlocked();
        else window.addEventListener('load', disableIfBlocked, { once: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rendi-showcase-wall"] && !Shopify.designMode) return;
  try {
    
  class RendiPartnerWall extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        const chip = event.target.closest('[data-kind-filter]');
        if (chip) this.filter(chip);
      });
    }

    // "Tutti" ha il filtro vuoto; una tile senza tipo ha data-kind vuoto e
    // quindi resta solo sotto "Tutti".
    filter(chip) {
      const kind = chip.dataset.kindFilter;
      for (const other of this.querySelectorAll('[data-kind-filter]')) {
        other.setAttribute('aria-pressed', String(other === chip));
      }
      for (const tile of this.querySelectorAll('[data-kind]')) {
        tile.toggleAttribute('data-filtered-out', kind !== '' && tile.dataset.kind !== kind);
      }
    }
  }

  if (!customElements.get('rendi-partner-wall')) {
    customElements.define('rendi-partner-wall', RendiPartnerWall);
  }

  } catch(e) { console.error(e); }
})();
})();
